import { useQuery } from "@tanstack/react-query";
import { OmsProduct, Stage } from "../lusca-search-api/generated-src";
import { OmsReportsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { useOmsIdentity } from "./omsContextIdentity";

export function useOmsOwnedExport(product: OmsProduct, jobId?: string | null) {
  const { namespace, financialAccount } = useOmsIdentity(product);
  return useQuery({
    queryKey: ["oms-owned-export", namespace, jobId],
    enabled: Boolean(jobId),
    retry: false,
    queryFn: async () =>
      (
        await OmsReportsApiFactory().getOmsExport(
          product,
          Stage.Prod,
          jobId!,
          financialAccount
        )
      ).data,
    refetchInterval: (data, query) =>
      !query.state.error && data?.status === "PREPARING" ? 3000 : false,
  });
}

export function useOmsOwnedSource(
  product: OmsProduct,
  jobId?: string | null,
  enabled = false
) {
  const { namespace, financialAccount } = useOmsIdentity(product);
  return useQuery({
    queryKey: ["oms-owned-source", namespace, jobId],
    enabled: Boolean(jobId) && enabled,
    retry: false,
    queryFn: async () =>
      (
        await OmsReportsApiFactory().getOmsExportSource(
          product,
          Stage.Prod,
          jobId!,
          financialAccount
        )
      ).data,
  });
}
